var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85 2.435l1.402 1.243-7.1 6.886-1.403-1.243c-.651-.577-1.73-.136-1.71.699l.116 4.753c.012.517.475.927 1.033.916l5.127-.107c.9-.02 1.327-1.038.676-1.615l-1.403-1.244 7.1-6.886 1.403 1.244c.652.577 1.73.136 1.71-.7l-.115-4.752C15.673 1.11 15.21.7 14.652.713L9.525.82c-.9.018-1.327 1.037-.676 1.615z"
  })));
}
export default SvgExpand;